import React from 'react';
import EditableHeader from '../../editor/editableHeader';
import EditablePar from '../../editor/editablePar';

export default function Quality() {
    return (
        <div className='default-page quality-page'>
            <EditableHeader textKey='quality-head-1' className='page-title'/>
            <section className='section'>
                <EditableHeader textKey='quality-head-2' className='section-title' headerType='h2'/>
                <EditablePar textKey='quality-text-1' className='section-par'/>
            </section>
            <section className='section'>
                <EditableHeader textKey='quality-head-3' className='section-title' headerType='h2'/>
                <EditablePar textKey='quality-text-2' className='section-par'/>
            </section>
        </div>
    );
}

Quality.displayName = 'Quality';